import { BettingStructure, PokerCategory, Prisma, type Table, TableType } from '@repo/database/src/types';
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';

import { LobbyIcon } from '../../enums/lobby-icons.enum';
import { PaginationOptionsDto } from '../../pagination-options-types';

export type LobbySortColumns = keyof Table | 'seats' | 'waitlist';

export class StakeOptionFilterDto {
  @IsEnum(BettingStructure)
  bettingStructure: BettingStructure;

  @IsNumber()
  min: number;

  @Type(() => Number)
  @IsNumber()
  @IsOptional()
  max: number | undefined;

  @IsBoolean()
  @IsOptional()
  minInclusive?: boolean;

  @IsBoolean()
  @IsOptional()
  maxInclusive?: boolean;
}

export class TableFilterDto {
  @IsEnum(TableType)
  @IsOptional()
  tableType?: TableType;

  @IsBoolean()
  @IsOptional()
  fullTables?: boolean;

  @IsBoolean()
  @IsOptional()
  emptyTables?: boolean;

  @IsBoolean()
  @IsOptional()
  huTables?: boolean;

  @IsNumber()
  @IsOptional()
  minBuyIn?: number;

  @IsNumber()
  @IsOptional()
  maxBuyIn?: number;

  @IsArray()
  @Type(() => Number)
  @IsNumber({}, { each: true })
  @IsOptional()
  maxPlayers?: number[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => StakeOptionFilterDto)
  @IsOptional()
  stakeOptions?: StakeOptionFilterDto[];

  @IsArray()
  @IsEnum(BettingStructure, { each: true })
  @IsOptional()
  gameTypes?: BettingStructure[];
}

export class TableQueryFilterDto extends TableFilterDto {
  @IsEnum(PokerCategory)
  @IsOptional()
  category?: PokerCategory;

  @IsString()
  @IsOptional()
  name?: string;

  @IsArray()
  @IsString({ each: true })
  @IsOptional()
  games?: string[];

  @IsArray()
  @IsEnum(LobbyIcon, { each: true })
  @IsOptional()
  lobbyIcons?: LobbyIcon[];
}

export class TableSortOptionsDto {
  @IsEnum(Prisma.SortOrder)
  sortOrder: Prisma.SortOrder;

  @IsString()
  orderBy: LobbySortColumns;
}

export class GetPublicTablesDto {
  @ValidateNested()
  @Type(() => TableQueryFilterDto)
  @IsOptional()
  filter?: TableQueryFilterDto;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TableSortOptionsDto)
  @IsOptional()
  sort?: TableSortOptionsDto[];

  @ValidateNested()
  @Type(() => PaginationOptionsDto)
  paginationOptions: PaginationOptionsDto;
}
